import { orderDisplayNumber } from "../../utils/orderDisplayNumber";
//Redux
import { useDispatch } from "react-redux";
import { setAlert, setComponentActive, setLastComponentActive, setLoading, setOrder } from "../../reducers/userConfigSlice";
//Components
import { OrderDetailResumed } from "../orderDetail";
import { LuClock10 } from "react-icons/lu";
import { FiShoppingBag } from "react-icons/fi";
import { PiPackage, PiPackageThin } from "react-icons/pi";
import { Button } from "../button";
import "./style.css";
import { translateMessage } from "@delibrandev/utils";
import { startDeliveryOrder } from "../../api/orders";

export const OrderDetailedResumed = ({ data, haveDetails = true }) => {
  const dispatch = useDispatch();

  const handleNavigation = (component, order = null) => {
    order !== null && dispatch(setOrder(order));
    dispatch(setLastComponentActive("orderResumedMap"));
    dispatch(setComponentActive("" + component));
  };

  const handleOrder = async () => {
      dispatch(setLoading(true));
      try {
        const payload = { orderId: data.orderId };
        const response = await startDeliveryOrder(payload);
        if (response && !response.error) {
          dispatch(setComponentActive("delivery"));
          //En este caso el loading false lo setea refreshOrders
          dispatch(setLoading(false));
        } else {
          
          dispatch(setAlert(translateMessage(response?.message || "Bad request")));
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setAlert(translateMessage(error?.message || "Bad request")));
        console.error("Error en la petición:", error);
        dispatch(setLoading(false));
      }
    };

  const DataResumed = ({ data }) => {
    //const totalProducts = data.products?.reduce((acc, product) => acc + product.quantity, 0) || 0;
    const deliveryTime = Math.floor((Date.now() - new Date(data.updatedAt).getTime()) / 60000);
    return (
      <div className="dataResumed">
        <div className="dataResumedItem">
          <LuClock10 size={"1.1rem"} />
          Hace {deliveryTime} min
        </div>
        <div className="dataResumedItem">
          <FiShoppingBag size={"1.1rem"} /> {orderDisplayNumber(data)}
        </div>
        <div className="dataResumedItem">
          <PiPackage size={"1.3rem"} /> {data && data.products && data.products.length}
        </div>
      </div>
    );
  };

  const OrderResumedInfo = ({ data }) => {
    switch (data.paymentStatus) {
      case "pending":
        return (
          <>
            <div className="order-resumed-state-pending">
              <div>{data.amounts?.total ?? "Pendiente de revisión"} €</div>
            </div>
            <div className="order-resumed-state-pending">Pendiente</div>
          </>
        );
      case "paid":
      case 1:
        return (
          <>
            <div className="order-resumed-state-success">
              <div>{data.amounts?.total ?? "Pendiente de revisión"} €</div>
            </div>
            <div className="order-resumed-state-success">Pagado</div>
          </>
        );
      default:
        break;
    }
  };

  return (
    <div className="containerBlock">
      <div
        className="order-header-page cursor"
        role="button"
        tabIndex={0}
        onClick={() => handleNavigation("orderResumedMap", data)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleNavigation("orderResumedMap", data);
          }
        }}
      >
        {/*<div className="order-avatar"></div>*/}
        <PiPackageThin size={45} />
        <div className="order-userData">
          <div className="order-userDataName">{data?.Customer?.fullname || ""}</div>
          <div className="order-userDataPhone">{data?.Customer?.phone || ""}</div>
        </div>
      </div>
      <OrderDetailResumed content={<DataResumed data={data} />} className="order-row-last" />
      <div className="order-resumed-footer">
        <div className="order-resumed-footer-info">
          <OrderResumedInfo data={data} />
        </div>
        <div className="order-resumed-footer-action">
          {haveDetails && (
            <Button text={"Detalles"} icon={null} customClass={""} action={() => handleNavigation("orderDetails", data)} />
          )}
          {data.status === "inDelivery" ? <Button
            text={"Entregar pedido"}
            icon={null}
            customClass={"customButtonGreen"}
            action={() => handleNavigation("payment", data)}
          />
          : data.status === "prepared" ? <Button
            text={"Iniciar entrega"}
            icon={null}
            customClass={"customButtonPending"}
            action={handleOrder}
          /> : (
            <p role="status">
              {data.status === "delivered"
                ? "Pedido entregado. No hay acciones de entrega pendientes."
                : `Entrega no disponible en este estado (${data.status || "desconocido"}).`}
            </p>
          )
      }
        </div>
      </div>
    </div>
  );
};
